<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('dzrz.title')}}</div>
        </div>
        <div class="cotainer">
            <div class="tips">{{$t('dzrz.sdddz')}}</div>
            <div class="input-box"><input id="address" class="input" v-model="address" type="text" :placeholder="$t('dzrz.tips')"></div>
            <div class="tips2">{{$t('dzrz.ts')}}</div>
            <div class="tips">{{$t('dzrz.tpsc')}}</div>
            <div class="upload-box" v-if="address_img"><img class="upload" :src="address_img" alt=""></div>
            <div class="upload-box" v-else><img v-if="!theme" class="upload" src="@/assets/my2/btn-upload.png" @click="upload" alt=""><img v-else class="upload" src="@/assets/theme/shangchuan1.png"  @click="upload" alt=""></div>
        </div>
        <button class="btn-login btn-bg" v-if="address_auth_status == 1">{{$t('gjrz.shz')}}</button>
        <button class="btn-login btn-bg" v-else-if="address_auth_status == 2">{{$t('gjrz.shtg')}}</button>
        <button class="btn-login btn-bg" v-else @click="sure">{{$t('gjrz.t4')}}</button>
        <div class="load-box" v-show="isLoad" @click="hideLoad"><img class="load" src="@/assets/loading.gif" alt=""></div>
    </div>
</template>

<script>
import lrz from "lrz";
export default {
    name: 'addressAuth',
    data () {
        return {
            isLoad: false,
            token: '',
            address: '',
            address_img: '',
            theme: false,
            address_auth_status: 0,
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.token = localStorage.getItem('token')
    },
    mounted() {
        this.getCenterLevel();
    },
    methods: {
       back(){
           this.$router.push('/user')
       },
       getCenterLevel(){
           let that = this;
           let params = {
               level:1
           }
           this.$ajax.get('/web/getCenterLevel',{params}).then((res) => {
                let resData = res.data.data;
                that.address = resData.address;
                that.address_img = resData.address_img
                that.address_auth_status = resData.address_auth_status
                if(resData.address_auth_status == 1 || resData.address_auth_status == 2){
                    $('#address').attr('disabled',true)
                }else{
                    $('#address').attr('disabled',false)
                }
            }).catch(function(err){
                console.log(err)
            })
       },
       sure(){
            let params = {
                address: this.address,
                address_img: this.address_img
            }
            if(!this.address){
                this.$toast.center(this.$t('dzrz.tips'));
                return false;
            }
            if(!this.address_img){
                this.$toast.center(this.$t('dzrz.qsczdtp'));
                return false;
            }
            this.$ajax.post('/web/setAddressAuth',params).then((res) => {
                let resData = res.data;
                if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                    setTimeout(() => {
                        this.$router.push('/user')
                    }, 1000)
                }else{
                    this.$toast.center(resData.message);
                    return;
                }

            }).catch(function(err){
                console.log(err)
            })
        },
        hideLoad(){
            this.isLoad = false
        },
        upload(){
            var that = this;
            this.uploadimg(function (res) {
                that.address_img = res.url
            })
        },
        uploadimg(callback){
			let that = this;
			that.ele_input(function(res) {
				if (res.length > 0) {
					var formdata = new FormData();
					for (var i = 0, len = res.length; i < len; i++) {
            lrz(res[0]).then(function (rst) {
              var formdata = new FormData();
              let file = new window.File([rst.file],rst.origin.name, {type: rst.file.type});
              formdata.append('file', file);
              formdata.append('token', that.token);
              formdata.append('app', 'h5');
              that.isLoad = true;
              $.ajax({
                url: that.domain + "/web/uploadImg",
                type: "POST",
                data: formdata,
                cache: false,
                processData: false,
                contentType: false,
                success: function(data) {
                  if (typeof data == 'string') data = JSON.parse(data.data)
                  if (data && data.code == 0) {
                    that.isLoad = false;
                    that.address_img = data.data.url;
                  }else{
                    that.isLoad = false;
                    that.$toast.center(data.message);
                    return;
                  }
                },error: function(data) {
                  that.isLoad = false;
                  that.$toast.center(data.message);
                  return;
                }
              });
            })
					}
        }
			})
		},
		ele_input(callback){
			var inputs = document.querySelector('.___input')
			if (!!inputs) {
				inputs.onchange = null
				inputs.onclick = null
				inputs.remove(0)
				// inputs.removeChild && inputs.removeChild(0)
			}
			var input = document.createElement('input')
			input.className = '___input'
			input.type = 'file'
			input.style.display = 'none'
			input.onchange = function() {
				var arr = []
				for (var i = 0, len = this.files.length; i < len; i++) {
					arr.push(this.files[i])
				}
				callback(arr)
			}
			input.accept = 'image/*'
			input.click();
			document.body.appendChild(input);
		},
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .4rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .record{
        position: absolute;
        top: 50%;
        right: .3rem;
        width: .6rem;
        height: .6rem;
        margin-top: -.3rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 1.42rem;
        width: 100%;
        padding: 0 .48rem;
        background: #fff;
        box-sizing: border-box;
        overflow-y: scroll;
    }
    .tips{
        padding: .6rem 0;
        color: #000;
        font-size: .4rem;
    }
    .tips2{
        padding: .3rem 0;
        color: #bcbcbc;
        font-size: .36rem;
    }
    .input-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #ececec;
    }
    .input-box .input{
        flex: 1;
        padding: .32rem 0;
        font-size: .4rem;
    }
    .input-box .input::placeholder{
        color: #d7d7d7;
        font-size: .36rem;
    }
    .input-box .t1{
        padding: 0 .3rem;
        color: #a6a6a6;
        font-size: .48rem;
        border-right: 1px solid #d7d77d;
    }
    .input-box .t2{
        padding-left: .3rem;
        color: #000;
        font-size: .48rem;
    }
    .upload{
        width: 3.3rem;
        height: 3.3rem;
    }
    .btn-login{
        position: fixed;
        left: .44rem;
        right: .44rem;
        bottom: .42rem;
        width: 9.92rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/addressAuth.vue